import { Badge } from "reactstrap";
import "../assets/scss/components/_custom-badges.scss";

export const getStatusBadge = (status: string, icon?: boolean) => {
  switch (status?.toLowerCase()) {
    case "paid":
      return (
        <Badge className="badge-soft-success-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Paid
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "pending":
      return (
        <Badge className="badge-soft-danger-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Pending
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "overdue":
      return (
        <Badge className="badge-soft-danger-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Overdue
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "draft":
      return (
        <Badge className="badge-soft-secondary-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Draft
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "due":
      return (
        <Badge className="badge-soft-secondary-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Due
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "approved":
      return (
        <Badge className="badge-soft-primary-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Approved
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "completed":
      return (
        <Badge className="badge-soft-success-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Completed
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "cancelled":
      return (
        <Badge className="badge-soft-danger-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Cancelled
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "rejected":
      return (
        <Badge className="badge-soft-danger-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Rejected
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "sent":
      return (
        <Badge className="badge-soft-info-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Sent
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "received":
      return (
        <Badge className="badge-soft-success-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Received
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    case "failed":
      return (
        <Badge className="badge-soft-danger-custom" color="">
          <div className="d-flex align-items-center gap-1 justify-content-center">
            Failed
            {icon && <i className="ri-arrow-down-s-line fs-24 " />}
          </div>
        </Badge>
      );

    default:
      return <Badge className="badge-soft-secondary-custom">{status}</Badge>;
  }
};
